import type { ApiResponse, OccupationDetailsFormData } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postOccupationDetails: builder.mutation<ApiResponse, OccupationDetailsFormData>({
      query: (body) => ({
        url: 'users/occupation',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePostOccupationDetailsMutation } = extendedApiSlice;
